import { render } from "./UserCenter.vue?vue&type=template&id=33488aec&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=33488aec&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33488aec"]])

export default __exports__